import { render } from "./PatientHistory.vue?vue&type=template&id=05cc76b3&scoped=true"
import script from "./PatientHistory.vue?vue&type=script&lang=js"
export * from "./PatientHistory.vue?vue&type=script&lang=js"

import "./PatientHistory.vue?vue&type=style&index=0&id=05cc76b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cc76b3"]])

export default __exports__